var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container main-content article-content main-content--profile-ideas"},[_c('div',{staticClass:"section--ideas-grid"},[_c('IdeasGrid')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }